import { Component, OnInit,ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { DeviceService } from '../services/device.service';
import { UserService } from '../services/user.service';
import { Message } from 'primeng/primeng';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-fuel-consumption-report',
  templateUrl: './fuel-consumption-report.component.html',
  styleUrls: ['./fuel-consumption-report.component.css']
})
export class FuelConsumptionReportComponent implements OnInit {

  fileName:String;
  groupBy:String;
  groupsBy: SelectItem[];
  position:any;
  options: any;
  overlays: any[];
  displayLocation: boolean=false;
  records : any [];
  devices: SelectItem[];
  dateOptions: SelectItem[];
  dateOption: any;
  deviceSelected: any;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  initialDate: Date;
  finalDate: Date;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  cols: any[];
  fuelConsumptionTotal:number=0;
  maxDays:number=35;
  @ViewChild('dt') table: Table;

  constructor(private positionService:PositionService,private deviceService : DeviceService,
    private userService: UserService) { }

    ngOnInit() {
      this.cols = [
        { field: 'name', header: 'NOMBRE' },
        { field: 'from', header: 'DESDE' },
        { field: 'to', header: 'HASTA' },
        { field: 'distance', header: 'DISTANCIA (km)' },
        { field: 'fuelConsumption', header: 'CONSUMO COMBUSTIBLE (Lts.)' }
      ];
      this.dateOptions = [
        {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
        {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
        {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
        {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
      ];
      this.groupsBy = [
        {label: 'Ninguno', value: ''},
        {label: 'Dia', value: 'D'},
        {label: 'Semana', value: 'W'}
      ];

      this.devices = [];
      this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        response.devices.forEach(item => {
          this.devices.push({label: item.name, value: item});
        });
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
      this.dateOption = '7';
      this.groupBy='';
      this.changeDate();
    }

    changeDate(){
      this.disabledInitialDate = true;
      this.disabledFinalDate = true;
      let dateTime = new Date();
      if(this.dateOption == 'T'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
      }else if(this.dateOption == 'Y'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 23, 59, 59));
      }else if(this.dateOption == '7'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 6, 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
      }else{
        this.disabledInitialDate = false;
        this.disabledFinalDate = false;
      }
    }

    diferenciaEntreFechasEnDias(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar(){
      if(this.table){
        this.table.first=1;
      }
      this.fileName="ConsumoCombustible_"+this.deviceSelected.name;

      if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
        return;
      }
      if(this.initialDate >= this.finalDate){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
        return;
      }
      this.blockedDocument = true;

      this.positionService.findDistanceFuelConsumption(this.deviceSelected.idDevice,this.initialDate,this.finalDate,this.groupBy).then(data => {
        let response: any = data;
        this.records = [...response.records];
        this.records.forEach(record => {
          record.latitudeFrom = record.latitudeFrom.toFixed(6);
          record.longitudeFrom = record.longitudeFrom.toFixed(6);
          record.latitudeTo = record.latitudeTo.toFixed(6);
          record.longitudeTo = record.longitudeTo.toFixed(6);
          record.latLngTo = record.latitudeTo+", "+record.longitudeTo;
          record.latLngFrom = record.latitudeFrom+", "+record.longitudeFrom;
          record.speed = record.speed.toFixed(2);
          record.distance = record.distance.toFixed(2);
          record.engineHours = "Encendido: "+record.durationOn+"\nApagado:"+record.durationOff+"\nOcio:"+record.durationLeisure;
        });
        console.log(response);
        console.log(response.totalFuelConsumption);
        this.fuelConsumptionTotal = +Number(response.totalFuelConsumption).toFixed(2);
        console.log(this.fuelConsumptionTotal);
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });

    }
    showFromInMap(position:any){
      this.overlays = [];
      this.displayLocation = true;
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.options = {
        zoom: 13,
        center:latLng
      };
      let marker = new google.maps.Marker({position: latLng});
      this.position = position;
      this.overlays.push(marker);
    }

    showToInMap(position:any){
      this.overlays = [];
      this.displayLocation = true;
      let latLng = new google.maps.LatLng(position.latitudeTo, position.longitudeTo);
      this.options = {
        zoom: 13,
        center:latLng
      };
      let marker = new google.maps.Marker({position: latLng});
      this.position = position;
      this.overlays.push(marker);
    }

    hide(){
      this.displayLocation = false;
    }

    exportXLS(){
      let records = [];
      this.records.forEach(item=>{
        let data = {};
        this.cols.forEach(col => {
          data[col.header] = item[col.field];
        });
        records.push(data);
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
      const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      XLSX.writeFile(workbook, this.fileName+".xlsx");
    }

    exportPDF() {
      window.open(environment.reportsEndPoint + 'viewFuelConsumptionReport?' +
        'idDevice=' + this.deviceSelected.idDevice +
        '&groupBy=' + this.groupBy +
        '&startDate=' + this.initialDate.toISOString() +
        '&endDate=' + this.finalDate.toISOString(), '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/app/fuel-consumption-report/fuel-consumption-report.component.ts